export class CurrentUserVideoOptions {
  public frameRate: number;
  public resolution: { width: number; height: number };
}
